import RegisterPersonalDataError from './RegisterPersonalDataError';
class InvalidGender extends RegisterPersonalDataError {
    constructor(gender, options) {
        super(`Can not register gender: ${gender}`, options);
    }
}
export default InvalidGender;
